import { create } from 'zustand'

import { Setters, State } from './types'
import { initialState } from './state'

export const usePropertiesStore = create<State & Setters>((set) => ({
  ...initialState,
  setProperties: (value) =>
    set(() => ({
      properties: value,
    })),
  setFirtsTime: (value) =>
    set(() => ({
      firtsTime: value,
    })),
  setPropertyLoaderStatus: (value) =>
    set(() => ({
      propertyLoaderStatus: value,
    })),

  setPage: (value) =>
    set(() => ({
      page: value,
    })),
  setHoveredPropertyCard: (value) =>
    set(() => ({
      hoveredPropertyCard: value,
    })),
}))
